import { Directive, Input, AfterViewChecked, ElementRef, OnChanges, Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Directive({
    selector: '[locTranslate]',
    standalone: false
})

export class TranslatorDirective implements AfterViewChecked, OnChanges {
    @Input()
    locTranslate: string;

    @Input()
    replaceData: any;

    private _lastLanguage:string = null;

    constructor(private el: ElementRef, private localizationService:LocalizationService) {
    }

    ngOnChanges() {
        this._doTranslation();
    }

    ngAfterViewChecked() {
        if(this.localizationService.currentLanguage != this._lastLanguage) {
            this._doTranslation();
        }
    }

    private _doTranslation() {
        this._lastLanguage = this.localizationService.currentLanguage;

        this.el.nativeElement.innerHTML = this.localizationService.translate(this.locTranslate, this.replaceData);
    }
}

@Directive({
    selector: '[locFormat]',
    standalone: false
})

export class FormatterDirective implements AfterViewChecked, OnChanges {
    @Input()
    locFormat: string;

    @Input()
    formatValue: any;

    @Input()
    formatParam: any;

    @Input()
    formatExtraParam: any;

    @Input()
    placeholder: string;

    private _lastLanguage:string = null;

    constructor(private el: ElementRef, private localizationService:LocalizationService) {
    }

    ngOnChanges() {
        this._doFormat();
    }

    ngAfterViewChecked() {
        if(this.localizationService.currentLanguage != this._lastLanguage) {
            this._doFormat();
        }
    }

    private _doFormat() {
        this._lastLanguage = this.localizationService.currentLanguage;

        let _cFn = this.localizationService.format[this.locFormat];

        if(_cFn == null) {
            this.el.nativeElement.innerHTML = this.placeholder || '';
        }
        else {
            let _argsArray = [];

            if(this.formatValue != null) {
                _argsArray.push(this.formatValue);

                if(this.formatParam != null) {
                    _argsArray.push(this.formatParam);
                }

                if(this.formatExtraParam != null) {
                    _argsArray.push(this.formatExtraParam);
                }
            }

            this.el.nativeElement.innerHTML = _cFn.apply(this.localizationService.format, _argsArray) || this.placeholder || '';
        }
    }
}